import React from 'react'
import { Label } from 'recharts'
import styled from 'styled-components'

const Container = styled.div`
  font-size: 14px;
`

export default ({ theme, content, viewBox, ...rest }) => (
  <Container
    as={Label}
    {...rest}
    viewBox={{
      ...viewBox,
      y: viewBox.y - 2,
    }}
    position='right'
  >
    Age
  </Container>
)
